import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import OrderReturn from 'view/orderReturn';

const OrderReturnPage = () => {
	return (
		<PageTemplate>
			<OrderReturn />
		</PageTemplate>
	);
};

export default OrderReturnPage;

 